"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { useNetlifyForm, netlifyFormMessage } from "@/components/use-netlify-form";
import { FormStatus } from "@/components/form-status";
import { DatePickerField } from "@/components/ui/date-picker";
import { TimePickerField } from "@/components/ui/time-picker";
import workshopData from "@/content/winter-workshop-services-2025-2026.json";
interface ContactFormProps {
  locale: string;
}
interface EquipmentService {
  serviceId: string;
  quantity: number;
}
interface Equipment {
  id: string;
  type: string;
  brand: string;
  services: EquipmentService[];
}

// Service category mapping for equipment types
const categoryMapping: Record<string, string[]> = {
  ski: ["ski-snow-maintenance", "ski-snow-repairs", "touring-services"],
  snowboard: ["ski-snow-maintenance", "ski-snow-repairs"],
  snowscoot: ["ski-snow-maintenance", "ski-snow-repairs"],
  other: [] // Show all
};
export default function ContactFormWinterWorkshop(t0) {
  const $ = _c(203);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      id: "1",
      type: "",
      brand: "",
      services: []
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [equipment, setEquipment] = useState(t1);
  const [sameDayService, setSameDayService] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [depositDate, setDepositDate] = useState("");
  const t = useTranslations("ContactWinter");
  const today = new Date().toISOString().split("T")[0];
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setEquipment([{
        id: "1",
        type: "",
        brand: "",
        services: []
      }]);
      setSameDayService(false);
      setTotalPrice(0);
      setDepositDate("");
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    status: netlifyStatus,
    handleSubmit: handleNetlifySubmit
  } = useNetlifyForm(t2);
  let t3;
  let t4;
  if ($[2] !== equipment || $[3] !== sameDayService) {
    t3 = () => {
      let total = 0;
      equipment.forEach(equip => {
        equip.services.forEach(service => {
          const serviceData = workshopData.categories.flatMap(_temp).find(s => s.id === service.serviceId);
          if (serviceData && typeof serviceData.price === "number") {
            total = total + serviceData.price * service.quantity;
            total;
          }
        });
      });
      if (sameDayService) {
        total = total + 5;
        total;
      }
      setTotalPrice(total);
    };
    t4 = [equipment, sameDayService];
    $[2] = equipment;
    $[3] = sameDayService;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== equipment) {
    t5 = () => {
      setEquipment([...equipment, {
        id: Date.now().toString(),
        type: "",
        brand: "",
        services: []
      }]);
    };
    $[6] = equipment;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const addEquipment = t5;
  let t6;
  if ($[8] !== equipment) {
    t6 = id => {
      if (equipment.length > 1) {
        setEquipment(equipment.filter(equip_0 => equip_0.id !== id));
      }
    };
    $[8] = equipment;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const removeEquipment = t6;
  let t7;
  if ($[10] !== equipment) {
    t7 = (id_0, field, value) => {
      setEquipment(equipment.map(equip_1 => {
        if (equip_1.id === id_0 && field === "type") {
          return {
            ...equip_1,
            [field]: value,
            services: []
          };
        }
        return equip_1.id === id_0 ? {
          ...equip_1,
          [field]: value
        } : equip_1;
      }));
    };
    $[10] = equipment;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const updateEquipment = t7;
  let t8;
  if ($[12] !== equipment) {
    t8 = (equipmentId, serviceId) => {
      setEquipment(equipment.map(equip_2 => {
        if (equip_2.id === equipmentId) {
          const existingService = equip_2.services.find(s_0 => s_0.serviceId === serviceId);
          if (existingService) {
            return {
              ...equip_2,
              services: equip_2.services.filter(s_1 => s_1.serviceId !== serviceId)
            };
          } else {
            return {
              ...equip_2,
              services: [...equip_2.services, {
                serviceId,
                quantity: 1
              }]
            };
          }
        }
        return equip_2;
      }));
    };
    $[12] = equipment;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const toggleService = t8;
  let t9;
  if ($[14] !== equipment) {
    t9 = (equipmentId_0, serviceId_0, quantity) => {
      setEquipment(equipment.map(equip_3 => {
        if (equip_3.id === equipmentId_0) {
          if (quantity === 0) {
            return {
              ...equip_3,
              services: equip_3.services.filter(s_2 => s_2.serviceId !== serviceId_0)
            };
          } else {
            return {
              ...equip_3,
              services: equip_3.services.map(s_3 => s_3.serviceId === serviceId_0 ? {
                ...s_3,
                quantity
              } : s_3)
            };
          }
        }
        return equip_3;
      }));
    };
    $[14] = equipment;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const updateServiceQuantity = t9;
  const getServicePrice = _temp3;
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = serviceId_2 => {
      const p = getServicePrice(serviceId_2);
      return typeof p === "number" ? p : 0;
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const getServicePriceNum = t10;
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = (serviceId_3, quantity_0) => {
      const p_0 = getServicePrice(serviceId_3);
      return typeof p_0 === "number" ? `${p_0 * quantity_0}€` : String(p_0);
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const formatLinePrice = t11;
  const getServiceName = _temp5;
  let t12;
  if ($[18] !== equipment) {
    t12 = (equipmentId_1, serviceId_5) => {
      const equip_4 = equipment.find(e => e.id === equipmentId_1);
      return equip_4?.services.some(s_6 => s_6.serviceId === serviceId_5) || false;
    };
    $[18] = equipment;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const isServiceSelected = t12;
  let t13;
  if ($[20] !== equipment) {
    t13 = (equipmentId_2, serviceId_6) => {
      const equip_5 = equipment.find(e_0 => e_0.id === equipmentId_2);
      const service_2 = equip_5?.services.find(s_7 => s_7.serviceId === serviceId_6);
      return service_2?.quantity || 0;
    };
    $[20] = equipment;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const getServiceQuantity = t13;
  const getFilteredCategories = _temp6;
  let t14;
  if ($[22] !== equipment || $[23] !== formatLinePrice || $[24] !== getServiceName) {
    t14 = () => {
      const equipmentData = equipment.map((equip_6, index) => {
        const equipServices = equip_6.services.map(service_3 => `${getServiceName(service_3.serviceId)} x${service_3.quantity} (${formatLinePrice(service_3.serviceId, service_3.quantity)})`).join(", ");
        return `Equipment ${index + 1}: ${equip_6.type || "Not specified"} - ${equip_6.brand || "Not specified"}\nServices: ${equipServices || "None selected"}`;
      }).join("\n\n");
      return equipmentData;
    };
    $[22] = equipment;
    $[23] = formatLinePrice;
    $[24] = getServiceName;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const prepareFormData = t14;
  let t15;
  let t16;
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <input type="hidden" name="form-name" value="contact-winter-workshop" />;
    t16 = <input type="hidden" name="formType" value="workshop" />;
    t17 = <input type="hidden" name="season" value="winter" />;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t15 = $[26];
    t16 = $[27];
    t17 = $[28];
  }
  let t18;
  if ($[29] !== prepareFormData) {
    t18 = prepareFormData();
    $[29] = prepareFormData;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18) {
    t19 = <input type="hidden" name="equipmentData" value={t18} />;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const t20 = `${totalPrice}€`;
  let t21;
  if ($[33] !== t20) {
    t21 = <input type="hidden" name="totalPrice" value={t20} />;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="hidden"><label>Don't fill this out if you're human:{" "}<input name="bot-field" /></label></p>;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t) {
    t23 = t("firstName");
    $[36] = t;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23) {
    t24 = <label htmlFor="firstName" className="block text-base font-medium mb-2">{t23} *</label>;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <input type="text" id="firstName" name="firstName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t24) {
    t26 = <div>{t24}{t25}</div>;
    $[41] = t24;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t) {
    t27 = t("lastName");
    $[43] = t;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t27) {
    t28 = <label htmlFor="lastName" className="block text-base font-medium mb-2">{t27} *</label>;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <input type="text" id="lastName" name="lastName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== t28) {
    t30 = <div>{t28}{t29}</div>;
    $[48] = t28;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t) {
    t31 = t("email");
    $[50] = t;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== t31) {
    t32 = <label htmlFor="email" className="block text-base font-medium mb-2">{t31} *</label>;
    $[52] = t31;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  let t33;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <input type="email" id="email" name="email" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t32) {
    t34 = <div>{t32}{t33}</div>;
    $[55] = t32;
    $[56] = t34;
  } else {
    t34 = $[56];
  }
  let t35;
  if ($[57] !== t) {
    t35 = t("phone");
    $[57] = t;
    $[58] = t35;
  } else {
    t35 = $[58];
  }
  let t36;
  if ($[59] !== t35) {
    t36 = <label htmlFor="phone" className="block text-base font-medium mb-2">{t35}</label>;
    $[59] = t35;
    $[60] = t36;
  } else {
    t36 = $[60];
  }
  let t37;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[61] = t37;
  } else {
    t37 = $[61];
  }
  let t38;
  if ($[62] !== t36) {
    t38 = <div>{t36}{t37}</div>;
    $[62] = t36;
    $[63] = t38;
  } else {
    t38 = $[63];
  }
  let t39;
  if ($[64] !== t) {
    t39 = t("depositDate");
    $[64] = t;
    $[65] = t39;
  } else {
    t39 = $[65];
  }
  let t40;
  if ($[66] !== t39) {
    t40 = <label htmlFor="depositDate" className="text-base font-medium">{t39} *</label>;
    $[66] = t39;
    $[67] = t40;
  } else {
    t40 = $[67];
  }
  const t41 = locale === "fr" ? "ex: 15/12/2025" : "e.g. 15/12/2025";
  let t42;
  if ($[68] !== t41) {
    t42 = <span className="text-sm text-muted-foreground">{t41}</span>;
    $[68] = t41;
    $[69] = t42;
  } else {
    t42 = $[69];
  }
  let t43;
  if ($[70] !== t40 || $[71] !== t42) {
    t43 = <div className="flex items-center justify-between mb-2">{t40}{t42}</div>;
    $[70] = t40;
    $[71] = t42;
    $[72] = t43;
  } else {
    t43 = $[72];
  }
  const t44 = locale === "fr" ? "Heure de d\xE9p\xF4t" : "Deposit Time";
  let t45;
  if ($[73] !== t44) {
    t45 = <label htmlFor="depositTime" className="text-base font-medium">{t44}</label>;
    $[73] = t44;
    $[74] = t45;
  } else {
    t45 = $[74];
  }
  const t46 = locale === "fr" ? "ex: 10:00" : "e.g. 10:00";
  let t47;
  if ($[75] !== t46) {
    t47 = <span className="text-sm text-muted-foreground">{t46}</span>;
    $[75] = t46;
    $[76] = t47;
  } else {
    t47 = $[76];
  }
  let t48;
  if ($[77] !== t45 || $[78] !== t47) {
    t48 = <div className="flex items-center justify-between mb-2">{t45}{t47}</div>;
    $[77] = t45;
    $[78] = t47;
    $[79] = t48;
  } else {
    t48 = $[79];
  }
  const t49 = locale === "fr" ? "Choisir une heure" : "Pick a time";
  let t50;
  if ($[80] !== t49) {
    t50 = <TimePickerField name="depositTime" id="depositTime" placeholder={t49} />;
    $[80] = t49;
    $[81] = t50;
  } else {
    t50 = $[81];
  }
  let t51;
  if ($[82] !== t48 || $[83] !== t50) {
    t51 = <div>{t48}{t50}</div>;
    $[82] = t48;
    $[83] = t50;
    $[84] = t51;
  } else {
    t51 = $[84];
  }
  let t52;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center"><svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" /></svg></div>;
    $[85] = t52;
  } else {
    t52 = $[85];
  }
  let t53;
  if ($[86] !== t) {
    t53 = t("couponTitle");
    $[86] = t;
    $[87] = t53;
  } else {
    t53 = $[87];
  }
  let t54;
  if ($[88] !== t53) {
    t54 = <span className="font-bold text-sm text-foreground">{t53}</span>;
    $[88] = t53;
    $[89] = t54;
  } else {
    t54 = $[89];
  }
  let t55;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <span className="font-bold text-green-600 text-sm">-20%</span>;
    $[90] = t55;
  } else {
    t55 = $[90];
  }
  let t56;
  if ($[91] !== t54) {
    t56 = <div className="flex items-center gap-2 mb-1">{t54}{t55}</div>;
    $[91] = t54;
    $[92] = t56;
  } else {
    t56 = $[92];
  }
  let t57;
  if ($[93] !== t) {
    t57 = t("couponTitle");
    $[93] = t;
    $[94] = t57;
  } else {
    t57 = $[94];
  }
  let t58;
  if ($[95] !== t) {
    t58 = t("couponCodeLabel");
    $[95] = t;
    $[96] = t58;
  } else {
    t58 = $[96];
  }
  let t59;
  if ($[97] !== t57 || $[98] !== t58) {
    t59 = <input type="text" id="couponCode" name="couponCode" aria-label={t57} placeholder={t58} className="w-full px-3 py-2.5 text-base border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-background" />;
    $[97] = t57;
    $[98] = t58;
    $[99] = t59;
  } else {
    t59 = $[99];
  }
  let t60;
  if ($[100] !== t56 || $[101] !== t59) {
    t60 = <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg p-4 shadow-sm"><div className="flex items-center gap-4">{t52}<div className="flex-1 min-w-0">{t56}{t59}</div></div></div>;
    $[100] = t56;
    $[101] = t59;
    $[102] = t60;
  } else {
    t60 = $[102];
  }
  const t61 = "lg:col-span-8 space-y-6 bg-card rounded-lg";
  const t62 = locale === "fr" ? "Votre \xC9quipement" : "Your Equipment";
  let t63;
  if ($[103] !== t62) {
    t63 = <h2 className="text-xl font-bold">{t62}</h2>;
    $[103] = t62;
    $[104] = t63;
  } else {
    t63 = $[104];
  }
  const t64 = locale === "fr" ? "Ajouter \xC9quipement" : "Add Equipment";
  let t65;
  if ($[105] !== addEquipment || $[106] !== t64) {
    t65 = <button type="button" onClick={addEquipment} className="px-4 py-2 bg-secondary text-secondary-foreground rounded-lg font-semibold hover:bg-secondary/90 transition-colors text-sm">+ {t64}</button>;
    $[105] = addEquipment;
    $[106] = t64;
    $[107] = t65;
  } else {
    t65 = $[107];
  }
  let t66;
  if ($[108] !== t63 || $[109] !== t65) {
    t66 = <div className="flex justify-between items-center mb-4">{t63}{t65}</div>;
    $[108] = t63;
    $[109] = t65;
    $[110] = t66;
  } else {
    t66 = $[110];
  }
  let t67;
  if ($[111] !== equipment || $[112] !== getServicePriceNum || $[113] !== getServiceQuantity || $[114] !== isServiceSelected || $[115] !== locale || $[116] !== removeEquipment || $[117] !== t || $[118] !== toggleService || $[119] !== updateEquipment || $[120] !== updateServiceQuantity) {
    let t68;
    if ($[122] !== equipment.length || $[123] !== getServicePriceNum || $[124] !== getServiceQuantity || $[125] !== isServiceSelected || $[126] !== locale || $[127] !== removeEquipment || $[128] !== t || $[129] !== toggleService || $[130] !== updateEquipment || $[131] !== updateServiceQuantity) {
      t68 = (equip_7, equipIndex) => <div key={equip_7.id} className="mb-6 p-5 bg-card rounded-xl relative border border-border shadow-sm">{equipment.length > 1 && <button type="button" onClick={() => removeEquipment(equip_7.id)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-muted hover:bg-destructive/20 flex items-center justify-center text-muted-foreground hover:text-destructive transition-colors" aria-label="Remove equipment">✕</button>}<div className="flex items-center gap-3 mb-4 pb-3 border-b"><div className="w-8 h-8 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 flex items-center justify-center text-white"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 12.5c-1.5-1.5-3-3-4.5-3s-3 1.5-3 3 1.5 3 3 3 3-1.5 4.5-3z" /><path d="M3 21l7-7" /><path d="M17.5 6.5L21 3" /><path d="M14 3l7 7-3.5 3.5" /></svg></div><h4 className="font-bold text-lg">{locale === "fr" ? `Équipement ${equipIndex + 1}` : `Equipment ${equipIndex + 1}`}</h4></div><div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"><div><label htmlFor={`equipmentType-${equip_7.id}`} className="block text-base font-medium mb-2">{t("equipmentType")}</label><select id={`equipmentType-${equip_7.id}`} value={equip_7.type} onChange={e_1 => updateEquipment(equip_7.id, "type", e_1.target.value)} className="w-full px-4 py-3 text-base pr-10 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3cpath%20fill%3D%22%236b7280%22%20d%3D%22M10.293%203.293L6%207.586%201.707%203.293A1%201%200%2000.293%204.707l5%205a1%201%200%20001.414%200l5-5a1%201%200%2000-1.414-1.414z%22%2F%3E%3c%2Fsvg%3E')] bg-[length:12px] bg-[right_12px_center] bg-no-repeat"><option value="">{locale === "fr" ? "S\xE9lectionner..." : "Select..."}</option><option value="ski">{t("ski")}</option><option value="snowboard">{t("snowboard")}</option><option value="snowscoot">{t("snowscoot")}</option><option value="other">{locale === "fr" ? "Autre" : "Other"}</option></select></div><div><label htmlFor={`equipmentBrand-${equip_7.id}`} className="block text-base font-medium mb-2">{locale === "fr" ? "Marque" : "Brand"}</label><input type="text" id={`equipmentBrand-${equip_7.id}`} value={equip_7.brand} onChange={e_2 => updateEquipment(equip_7.id, "brand", e_2.target.value)} placeholder="e.g., Rossignol, K2, Salomon..." className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div></div>{equip_7.type && <div className="mt-4 pt-4 border-t"><h5 className="font-medium text-base mb-3">{locale === "fr" ? "Services Atelier" : "Workshop Services"}<span className="text-xs text-muted-foreground ml-2">{locale === "fr" ? "(Cliquez pour s\xE9lectionner)" : "(Click to select)"}</span></h5>{getFilteredCategories(equip_7.type).map(category => <div key={category.id} className="mb-3"><h6 className="text-sm font-semibold text-foreground mb-2">{category.name}</h6><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">{category.services.map(service_4 => {
                const isSelected = isServiceSelected(equip_7.id, service_4.id);
                const quantity_1 = getServiceQuantity(equip_7.id, service_4.id);
                return <div key={service_4.id} role="checkbox" aria-checked={isSelected} tabIndex={0} onClick={() => toggleService(equip_7.id, service_4.id)} onKeyDown={e_3 => {
                  if (e_3.key === "Enter" || e_3.key === " ") {
                    e_3.preventDefault();
                    toggleService(equip_7.id, service_4.id);
                  }
                }} className={`p-3 rounded-lg border-2 cursor-pointer transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${isSelected ? "border-primary bg-primary/20 shadow-sm" : "border-muted-foreground/30 bg-background hover:border-primary/60 hover:bg-muted/50"}`}><div className="flex justify-between items-start gap-2"><div className="flex-1 min-w-0"><div className="font-semibold text-sm truncate">{service_4.name}</div><div className="text-xs text-muted-foreground mt-0.5 font-medium">{typeof service_4.price === "number" ? `${service_4.price}€` : service_4.price} • {service_4.duration}</div></div>{isSelected && <div className="flex items-center gap-1" onClick={_temp7}><button type="button" aria-label={locale === "fr" ? "Diminuer la quantit\xE9" : "Decrease quantity"} onClick={() => updateServiceQuantity(equip_7.id, service_4.id, Math.max(0, quantity_1 - 1))} className="w-9 h-9 rounded bg-muted hover:bg-muted/80 flex items-center justify-center text-sm font-bold">−</button><span className="w-6 text-center text-sm font-semibold">{quantity_1}</span><button type="button" aria-label={locale === "fr" ? "Augmenter la quantit\xE9" : "Increase quantity"} onClick={() => updateServiceQuantity(equip_7.id, service_4.id, quantity_1 + 1)} className="w-9 h-9 rounded bg-primary text-primary-foreground hover:bg-primary/90 flex items-center justify-center text-sm font-bold">+</button></div>}</div></div>;
              })}</div></div>)}</div>}{!equip_7.type && <div className="mt-3 p-3 bg-muted/50 rounded text-sm text-muted-foreground text-center">{locale === "fr" ? "S\xE9lectionnez un type d'\xE9quipement pour voir les services disponibles" : "Select equipment type to see available services"}</div>}{equip_7.services.length > 0 && <div className="mt-3 p-2 bg-primary/10 rounded-lg border-l-4 border-primary"><div className="text-sm font-semibold flex justify-between"><span>{locale === "fr" ? "Sous-total:" : "Subtotal:"}</span><span className="text-primary">{equip_7.services.reduce((sum, s_8) => sum + getServicePriceNum(s_8.serviceId) * s_8.quantity, 0)}€</span></div></div>}</div>;
      $[122] = equipment.length;
      $[123] = getServicePriceNum;
      $[124] = getServiceQuantity;
      $[125] = isServiceSelected;
      $[126] = locale;
      $[127] = removeEquipment;
      $[128] = t;
      $[129] = toggleService;
      $[130] = updateEquipment;
      $[131] = updateServiceQuantity;
      $[132] = t68;
    } else {
      t68 = $[132];
    }
    t67 = equipment.map(t68);
    $[111] = equipment;
    $[112] = getServicePriceNum;
    $[113] = getServiceQuantity;
    $[114] = isServiceSelected;
    $[115] = locale;
    $[116] = removeEquipment;
    $[117] = t;
    $[118] = toggleService;
    $[119] = updateEquipment;
    $[120] = updateServiceQuantity;
    $[121] = t67;
  } else {
    t67 = $[121];
  }
  let t68;
  if ($[133] !== t66 || $[134] !== t67) {
    t68 = <div>{t66}{t67}</div>;
    $[133] = t66;
    $[134] = t67;
    $[135] = t68;
  } else {
    t68 = $[135];
  }
  let t69;
  if ($[136] !== t) {
    t69 = t("message");
    $[136] = t;
    $[137] = t69;
  } else {
    t69 = $[137];
  }
  let t70;
  if ($[138] !== t69) {
    t70 = <label htmlFor="message" className="block text-base font-medium mb-2">{t69}</label>;
    $[138] = t69;
    $[139] = t70;
  } else {
    t70 = $[139];
  }
  const t71 = locale === "fr" ? "D\xE9crivez vos besoins sp\xE9cifiques, l'\xE9tat de l'\xE9quipement, ou toute autre information pertinente..." : "Describe your specific needs, equipment condition, or any other relevant information...";
  let t72;
  if ($[140] !== t71) {
    t72 = <textarea id="message" name="message" rows={6} placeholder={t71} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[140] = t71;
    $[141] = t72;
  } else {
    t72 = $[141];
  }
  let t73;
  if ($[142] !== t70 || $[143] !== t72) {
    t73 = <div>{t70}{t72}</div>;
    $[142] = t70;
    $[143] = t72;
    $[144] = t73;
  } else {
    t73 = $[144];
  }
  let t74;
  if ($[145] !== t) {
    t74 = t("dueDate");
    $[145] = t;
    $[146] = t74;
  } else {
    t74 = $[146];
  }
  let t75;
  if ($[147] !== t74) {
    t75 = <label htmlFor="dueDate" className="text-base font-medium">{t74}</label>;
    $[147] = t74;
    $[148] = t75;
  } else {
    t75 = $[148];
  }
  const t76 = locale === "fr" ? "ex: 20/12/2025" : "e.g. 20/12/2025";
  let t77;
  if ($[149] !== t76) {
    t77 = <span className="text-sm text-muted-foreground">{t76}</span>;
    $[149] = t76;
    $[150] = t77;
  } else {
    t77 = $[150];
  }
  let t78;
  if ($[151] !== t75 || $[152] !== t77) {
    t78 = <div className="flex items-center justify-between mb-2">{t75}{t77}</div>;
    $[151] = t75;
    $[152] = t77;
    $[153] = t78;
  } else {
    t78 = $[153];
  }
  const T0 = DatePickerField;
  const t79 = "dueDate";
  const t80 = "dueDate";
  const t81 = depositDate ? new Date(depositDate) : new Date(today);
  const t82 = locale === "fr" ? "Choisir une date" : "Pick a date";
  let t83;
  if ($[154] !== T0 || $[155] !== locale || $[156] !== t81 || $[157] !== t82) {
    t83 = <T0 name={t79} id={t80} locale={locale} minDate={t81} placeholder={t82} />;
    $[154] = T0;
    $[155] = locale;
    $[156] = t81;
    $[157] = t82;
    $[158] = t83;
  } else {
    t83 = $[158];
  }
  let t84;
  if ($[159] !== t78 || $[160] !== t83) {
    t84 = <div>{t78}{t83}</div>;
    $[159] = t78;
    $[160] = t83;
    $[161] = t84;
  } else {
    t84 = $[161];
  }
  let t85;
  if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = e_5 => setSameDayService(e_5.target.checked);
    $[162] = t85;
  } else {
    t85 = $[162];
  }
  let t86;
  if ($[163] !== sameDayService) {
    t86 = <input type="checkbox" name="sameDayService" checked={sameDayService} onChange={t85} className="mt-0.5 w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary" />;
    $[163] = sameDayService;
    $[164] = t86;
  } else {
    t86 = $[164];
  }
  let t87;
  if ($[165] !== t) {
    t87 = t("sameDayService");
    $[165] = t;
    $[166] = t87;
  } else {
    t87 = $[166];
  }
  let t88;
  if ($[167] !== t87) {
    t88 = <span className="font-medium text-sm text-foreground">{t87} (+5€)</span>;
    $[167] = t87;
    $[168] = t88;
  } else {
    t88 = $[168];
  }
  const t89 = locale === "fr" ? "Service express le jour m\xEAme selon disponibilit\xE9." : "Express same-day service subject to availability.";
  let t90;
  if ($[169] !== t89) {
    t90 = <p className="text-xs text-muted-foreground mt-0.5">{t89}</p>;
    $[169] = t89;
    $[170] = t90;
  } else {
    t90 = $[170];
  }
  let t91;
  if ($[171] !== t88 || $[172] !== t90) {
    t91 = <div className="flex-1">{t88}{t90}</div>;
    $[171] = t88;
    $[172] = t90;
    $[173] = t91;
  } else {
    t91 = $[173];
  }
  let t92;
  if ($[174] !== t86 || $[175] !== t91) {
    t92 = <div className="border rounded-lg p-3 bg-card"><label className="flex items-start gap-3 cursor-pointer">{t86}{t91}</label></div>;
    $[174] = t86;
    $[175] = t91;
    $[176] = t92;
  } else {
    t92 = $[176];
  }
  let t93;
  if ($[177] !== equipment || $[178] !== formatLinePrice || $[179] !== getServiceName || $[180] !== getServicePriceNum || $[181] !== locale || $[182] !== sameDayService || $[183] !== totalPrice) {
    t93 = equipment.some(_temp8) && <div className="bg-muted/30 border rounded-xl p-6"><div className="flex justify-between items-center mb-5 pb-4 border-b"><h2 className="text-2xl font-bold text-foreground">{locale === "fr" ? "R\xE9capitulatif" : "Summary"}</h2><div className="text-3xl font-bold text-foreground">{totalPrice}€</div></div><div className="space-y-3"><div className="text-base font-bold text-foreground mb-3">{locale === "fr" ? "Services s\xE9lectionn\xE9s:" : "Selected services:"}</div>{equipment.map((equip_8, index_0) => {
          if (equip_8.services.length === 0) {
            return null;
          }
          return <div key={equip_8.id} className="bg-background border rounded-lg p-4"><div className="flex justify-between items-start mb-2"><div className="font-bold text-base text-foreground">{locale === "fr" ? `Équipement ${index_0 + 1}` : `Equipment ${index_0 + 1}`}{equip_8.type && <span className="text-muted-foreground font-medium ml-1">- {equip_8.type}</span>}</div><span className="font-bold text-base text-foreground">{equip_8.services.reduce((sum_0, s_9) => sum_0 + getServicePriceNum(s_9.serviceId) * s_9.quantity, 0)}€</span></div><div className="space-y-1">{equip_8.services.map(service_5 => <div key={service_5.serviceId} className="flex justify-between text-sm font-medium text-muted-foreground pl-2"><span>{getServiceName(service_5.serviceId)}{service_5.quantity > 1 && <span>{" "}×{service_5.quantity}</span>}</span><span>{formatLinePrice(service_5.serviceId, service_5.quantity)}</span></div>)}</div></div>;
        })}{sameDayService && <div className="bg-background border rounded-lg p-4"><div className="flex justify-between items-start"><div className="font-bold text-base text-foreground">{locale === "fr" ? "Service express" : "Express service"}</div><span className="font-bold text-base text-foreground">+5€</span></div><div className="text-sm font-medium text-muted-foreground">{locale === "fr" ? "Service le jour m\xEAme" : "Same-day service"}</div></div>}</div><div className="text-xs text-muted-foreground bg-muted/20 p-3 rounded-lg mt-4">{locale === "fr" ? "\uD83D\uDCA1 Prix estim\xE9 - Pi\xE8ces d\xE9tach\xE9es en suppl\xE9ment" : "\uD83D\uDCA1 Estimated price - Spare parts charged separately"}</div>{workshopData.notes && <div className="mt-4 pt-4 border-t text-xs space-y-1.5"><p>• <strong>{workshopData.notes.packageTitle}:</strong>{" "}{workshopData.notes.package}</p><p>• <strong>{workshopData.notes.warrantyTitle}:</strong>{" "}{workshopData.notes.warranty}</p></div>}</div>;
    $[177] = equipment;
    $[178] = formatLinePrice;
    $[179] = getServiceName;
    $[180] = getServicePriceNum;
    $[181] = locale;
    $[182] = sameDayService;
    $[183] = totalPrice;
    $[184] = t93;
  } else {
    t93 = $[184];
  }
  const t94 = netlifyStatus === "submitting";
  let t95;
  if ($[185] !== locale || $[186] !== netlifyStatus || $[187] !== t) {
    t95 = netlifyStatus === "submitting" ? netlifyFormMessage(locale, "submitting") : t("submitButton");
    $[185] = locale;
    $[186] = netlifyStatus;
    $[187] = t;
    $[188] = t95;
  } else {
    t95 = $[188];
  }
  let t96;
  if ($[189] !== t94 || $[190] !== t95) {
    t96 = <button type="submit" disabled={t94} className="w-full bg-primary text-primary-foreground px-6 py-4 text-lg rounded-lg font-semibold hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg disabled:opacity-60">{t95}</button>;
    $[189] = t94;
    $[190] = t95;
    $[191] = t96;
  } else {
    t96 = $[191];
  }
  let t97;
  if ($[192] !== locale || $[193] !== netlifyStatus) {
    t97 = <FormStatus status={netlifyStatus} locale={locale} />;
    $[192] = locale;
    $[193] = netlifyStatus;
    $[194] = t97;
  } else {
    t97 = $[194];
  }
  let t98;
  if ($[195] !== t68 || $[196] !== t73 || $[197] !== t84 || $[198] !== t92 || $[199] !== t93 || $[200] !== t96 || $[201] !== t97) {
    t98 = <div className={t61}>{t68}{t73}{t84}{t92}{t93}{t96}{t97}</div>;
    $[195] = t68;
    $[196] = t73;
    $[197] = t84;
    $[198] = t92;
    $[199] = t93;
    $[200] = t96;
    $[201] = t97;
    $[202] = t98;
  } else {
    t98 = $[202];
  }
  return <div className="bg-card rounded-lg border p-4 sm:p-6 lg:p-8 w-full max-w-[1440px] mx-auto"><form name="contact-winter-workshop" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleNetlifySubmit} className="space-y-6">{t15}{t16}{t17}{t19}{t21}{t22}<div className="grid grid-cols-1 lg:grid-cols-12 gap-6"><div className="lg:col-span-4 space-y-4 lg:p-6 lg:bg-muted/30 lg:rounded-lg">{t26}{t30}{t34}{t38}<div>{t43}<DatePickerField name="depositDate" id="depositDate" locale={locale} required={true} minDate={new Date(today)} value={depositDate} onValueChange={setDepositDate} placeholder={locale === "fr" ? "Choisir une date" : "Pick a date"} /></div>{t51}{t60}</div>{t98}</div></form></div>;
}
function _temp8(e_6) {
  return e_6.services.length > 0;
}
function _temp7(e_4) {
  return e_4.stopPropagation();
}
function _temp6(equipmentType) {
  if (!equipmentType || equipmentType === "other") {
    return workshopData.categories;
  }
  const allowedCategories = categoryMapping[equipmentType] || [];
  return workshopData.categories.filter(cat_2 => allowedCategories.includes(cat_2.id));
}
function _temp5(serviceId_4) {
  const service_1 = workshopData.categories.flatMap(_temp4).find(s_5 => s_5.id === serviceId_4);
  return service_1 ? service_1.name : "";
}
function _temp4(cat_1) {
  return cat_1.services;
}
function _temp3(serviceId_1) {
  const service_0 = workshopData.categories.flatMap(_temp2).find(s_4 => s_4.id === serviceId_1);
  return service_0 ? service_0.price : 0;
}
function _temp2(cat_0) {
  return cat_0.services;
}
function _temp(cat) {
  return cat.services;
}